module.exports = __webpack_public_path__ + "fonts/dripicons-v2.11fc83ae.woff";